import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";

import { loginRequest } from "~/app/main/auth-config.ts";

import { LoadingSpinner } from "../components/loading-spinner/loading-spinner.tsx";

/**
 * Component that triggers a B2C login redirect when rendered.
 * Shows a loading spinner while the redirect is being initiated.
 */
export function B2CLoginRedirect() {
	const { instance } = useMsal();

	useEffect(() => {
		void instance.loginRedirect(loginRequest).catch((error) => {
			console.error("Failed to initiate B2C login redirect:", error);
		});
	}, [instance]);

	return <LoadingSpinner />;
}
